import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  token: localStorage.getItem("token") || "",
  status: "",
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  getToken: (state) => state.token,
  authStatus: (state) => state.status,
};

const actions = {
  AUTH_REQUEST: ({ commit, dispatch }, user) => {
    return new Promise(async (resolve, reject) => {
      commit("AUTH_REQUEST");
      try {
        const { data } = await axios.post(`${backend_url}/auth/login`, user);
        if (data.token) {
          localStorage.setItem("token", data.token);
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${data.token}`;

          commit("AUTH_SUCCESS", data.token);
          // Wait for USER_REQUEST to complete before resolving
          // This ensures profile is loaded before navigation happens
          try {
            await dispatch("USER_REQUEST", data.token);
            resolve(data);
          } catch (userError) {
            // If USER_REQUEST fails, clear token and reject AUTH_REQUEST
            // The app cannot be in a valid authenticated state without a profile
            commit("AUTH_ERROR");
            localStorage.removeItem("token");
            delete axios.defaults.headers.common["Authorization"];
            reject(userError || { info: "Failed to load user profile" });
          }
        } else {
          throw data;
        }
      } catch (err) {
        commit("AUTH_ERROR");
        localStorage.removeItem("token");
        reject(err.response || err || "Authentication error");
      }
    });
  },
  AUTH_LOGOUT: ({ commit }) => {
    return new Promise((resolve) => {
      commit("AUTH_LOGOUT");
      localStorage.removeItem("token");
      resolve();
    });
  },
  AUTH_SIGNUP: ({ commit, dispatch }, user) => {
    return new Promise(async (resolve, reject) => {
      commit("AUTH_REQUEST");
      try {
        const { data } = await axios.post(`${backend_url}/auth/signup`, user);
        if (data.token) {
          localStorage.setItem("token", data.token);
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${data.token}`;
          commit("AUTH_SUCCESS", data.token);
          // Wait for USER_REQUEST to complete before resolving
          try {
            await dispatch("USER_REQUEST", data.token);
            resolve(data);
          } catch (userError) {
            // If USER_REQUEST fails, clear token and reject AUTH_REQUEST
            // The app cannot be in a valid authenticated state without a profile
            commit("AUTH_ERROR");
            localStorage.removeItem("token");
            delete axios.defaults.headers.common["Authorization"];
            reject(userError || { info: "Failed to load user profile" });
          }
        } else {
          throw data;
        }
      } catch (err) {
        commit("AUTH_ERROR");
        localStorage.removeItem("token");
        reject(err.response || err || "Authentication error");
      }
    });
  },
};

const mutations = {
  AUTH_REQUEST: (state) => {
    state.status = "loading";
  },
  AUTH_SUCCESS: (state, token) => {
    state.status = "success";
    state.token = token;
    state.hasLoadedOnce = true;
  },
  AUTH_ERROR: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  AUTH_LOGOUT: (state) => {
    state.token = "";
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
